import { render, staticRenderFns } from "./RcvScI_List.vue?vue&type=template&id=3a8bff4c"
import script from "./RcvScI_List.vue?vue&type=script&lang=js"
export * from "./RcvScI_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports